import React, { useState } from "react"
import { Box, Button, Popover, Checkbox, Typography } from "@mui/material"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import { COLORS } from "../../../../utils"

const CheckboxFilterPopover = ({ icon, label, items, selectedIds, onChange, emptyMessage, fullWidth = false }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const [draft, setDraft] = useState(selectedIds)
  const hasActive = selectedIds.length > 0
  const triggerSx = { ...(fullWidth ? sx.triggerFullWidth : sx.trigger), ...(hasActive ? sx.triggerActive : {}) }

  const handleOpen = (e) => {
    setDraft(selectedIds)
    setAnchorEl(e.currentTarget)
  }
  const handleClose = () => setAnchorEl(null)
  const toggleItem = (id) => setDraft((prev) => (prev.includes(id) ? prev.filter((d) => d !== id) : [...prev, id]))
  const handleReset = () => setDraft([])
  const handleSave = () => {
    onChange(draft)
    handleClose()
  }

  return (
    <>
      <Button variant="outlined" size="small" onClick={handleOpen} endIcon={<ExpandMoreIcon />} sx={triggerSx}>
        <Box className="flexRow center spaceBetween" sx={sx.triggerContent}>
          <Box className="flexRow center" sx={sx.triggerLabel}>
            {icon}
            <Box component="span">{label}</Box>
          </Box>
          {hasActive && <Box sx={sx.badge}>{selectedIds.length}</Box>}
        </Box>
      </Button>
      <Popover
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        slotProps={{ paper: { sx: sx.paper } }}
      >
        <Box className="flexColumn stretch" sx={sx.list}>
          {items.length === 0 && <Typography sx={sx.empty}>{emptyMessage}</Typography>}
          {items.map((item) => (
            <Box key={item.id} className="flexRow center pointer" sx={sx.row} onClick={() => toggleItem(item.id)}>
              <Checkbox size="small" checked={draft.includes(item.id)} sx={sx.checkbox} />
              <Typography sx={sx.rowLabel}>{item.label}</Typography>
            </Box>
          ))}
        </Box>
        <Box className="flexRow" sx={sx.footer}>
          <Button variant="outlined" onClick={handleReset} sx={sx.resetBtn}>RÉINITIALISER</Button>
          <Button variant="contained" onClick={handleSave} sx={sx.saveBtn}>ENREGISTRER</Button>
        </Box>
      </Popover>
    </>
  )
}

export default CheckboxFilterPopover

const sx = {
  trigger: { borderRadius: "999px", borderColor: COLORS.DEFAULT_GREY, color: COLORS.DARK_GREY, textTransform: "none", fontSize: 13 },
  triggerFullWidth: {
    width: "100%", height: "40px", justifyContent: "space-between", borderRadius: "4px",
    borderColor: COLORS.DEFAULT_GREY, color: COLORS.DARK_GREY, textTransform: "none", fontSize: 15, px: "14px",
  },
  triggerContent: { flex: 1, gap: "8px" },
  triggerLabel: { gap: "8px" },
  triggerActive: { borderColor: COLORS.PRIMARY_COLOR, color: COLORS.PRIMARY_COLOR, bgcolor: COLORS.PRIMARY_BLUE_50 },
  badge: {
    bgcolor: COLORS.PRIMARY_COLOR, color: COLORS.WHITE, borderRadius: "999px",
    fontSize: 10, fontWeight: 700, px: "6px", minWidth: 16, textAlign: "center",
  },
  paper: { width: 300, mt: "4px", borderRadius: "8px", overflow: "hidden" },
  list: { p: "8px", maxHeight: 320, overflowY: "auto" },
  row: { gap: "8px", p: "6px 8px", borderRadius: "6px", "&:hover": { bgcolor: COLORS.LIGHT_GREY_2 } },
  checkbox: { p: "4px" },
  rowLabel: { fontSize: 13, color: COLORS.GREY_900 },
  empty: { fontSize: 12, color: COLORS.DISABLED, textAlign: "center", p: "16px 8px" },
  footer: {
    gap: "8px", p: "10px 12px", borderTop: "1px solid", borderColor: COLORS.DEFAULT_GREY, bgcolor: COLORS.LIGHT_GREY_2,
  },
  resetBtn: { flex: 1, color: COLORS.DARK_GREY, borderColor: COLORS.DEFAULT_GREY },
  saveBtn: { flex: 1 },
}
